import { createReducer, on } from '@ngrx/store';
import { addContact, removeContact, setContacts, updateContact } from './contacts.action';
import { IContacts } from '../interfaces/contact.interfaces';

export const initialState = {
	contacts: [],
};

export function addContactFn(state: IContacts, { contact }) {
	const updatedContacts = [...state.contacts, contact];

	return { ...state, contacts: updatedContacts };
}

type updateContactActionPropType = ReturnType<typeof updateContact>;
export function updateContactFn(
	state: IContacts,
	{ contact, pk }: updateContactActionPropType
) {
	const updatedContacts = state.contacts.map(existingContact => {
		if (existingContact.pk === pk) {
			return { ...contact, pk };
		} else {
			return existingContact;
		}
	});

	return { ...state, contacts: updatedContacts };
}

export function removeContactFn(state: IContacts, { contactId }) {
	const updatedContacts = state.contacts.filter(contact => contact.pk !== contactId);

	return { ...state, contacts: updatedContacts };
}

export const contactsReducer = createReducer<IContacts>(
	initialState,
	on(setContacts, (state, { contacts }) => ({ ...state, contacts })),
	on(addContact, addContactFn),
	on(updateContact, updateContactFn),
	on(removeContact, removeContactFn)
);
